import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import Modal from 'components/Modal';
import API from '../../../../helpers/API';
import BulkActionSenderForm from './BulkActionSenderForm';
import styles from './styles.scss';
import {
  BULK_CUSTOM_EVENT_TYPE_BUTTON_LABEL,
  BULK_CUSTOM_EVENT_TYPE_MODAL_HEADER,
  BULK_CUSTOM_EVENT_TYPE_SUB_HEADER,
  BULK_CUSTOM_EVENT_TYPE_MODAL_ACTION_TEXT,
  BULK_CUSTOM_EVENT_TYPE_MODAL_CANCEL_TEXT,
  BULK_CUSTOM_EVENT_TYPE_MODAL_LABEL,
  BULK_CUSTOM_EVENT_TYPE_MODAL_DESCRIBED_BY,
  BULK_CUSTOM_EVENT_TYPE_ERROR,
  CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_SUB_HEADER,
  CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_HEADER,
  CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_CANCEL_TEXT,
  CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_ACTION_TEXT,
  CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_LABEL,
  CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_DESCRIBED_BY,
} from './constants';
import CustomEventTypes from '../../../../images/CustomEventTypes';

const BulkActionSender = ({
  modalOpen, modalTrigger, dashboard, tile, alertControl,
}) => {
  const [customEventValue, setCustomEventValue] = useState(null);
  const [customEventOptions, setCustomEventOptions] = useState([]);
  const [validationError, setValidationError] = useState({});
  const [dataError, setDataError] = useState(null);
  const [confirmBoxOpen, setConfirmBoxOpen] = useState(false);

  const validateFields = () => {
    if (!customEventValue) {
      setValidationError({ customEventType: [BULK_CUSTOM_EVENT_TYPE_ERROR] });
      return false;
    }
    setValidationError({});
    return true;
  };

  const clearState = () => {
    setValidationError({});
    setCustomEventValue(null);
    setDataError(null);
  };

  const getCustomEventTypes = async () => {
    try {
      const response = await API.getCustomEventTypes();
      if (response?.customEventTypes?.length) {
        const options = response.customEventTypes.map(evt => ({
          label: evt.name,
          value: evt.id,
        }));
        setCustomEventOptions([{ label: 'Select custom event', value: '' }, ...options]);
      }
    } catch {
      setDataError('Failed to fetch event types.');
    }
  };

  const bulkNotificationAction = async () => {
    try {
      const payload = {
        bulkActionType: 'SendCustomEventType',
        customEventTypeId: customEventValue,
        tileText: encodeURIComponent(tile),
        dashboardName: encodeURIComponent(dashboard),
      };
      await API.addBulkCustomEventType(payload);
      setConfirmBoxOpen(false);
      alertControl({ on: true, type: 'success', message: 'Request to trigger custom event has been sent!' });
      clearState();
    } catch (err) {
      setConfirmBoxOpen(false);
      alertControl({ on: true, type: 'error', message: 'Request to trigger custom event failed. Please try again, or contact support.' });
      clearState();
    }
  };

  const submitConfirmation = () => {
    if (validateFields()) {
      modalTrigger(false);
      setConfirmBoxOpen(true);
    }
  };

  useEffect(() => {
    if (modalOpen) {
      getCustomEventTypes();
    }
  }, [modalOpen]);

  useEffect(() => {
    if (!modalOpen) {
      setValidationError({});
      setDataError(null);
    }
  }, [modalOpen]);

  useEffect(() => {
    if (!confirmBoxOpen) {
      clearState();
    }
  }, [confirmBoxOpen]);

  return (
    <div>
      <button
        onClick={() => modalTrigger(true)}
        className={cx(styles.mainButton, styles.buttonTheme)}
        type="button"
        style={{
          minHeight: '2.5rem', width: 'auto', minWidth: '13rem', borderRadius: '4px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CustomEventTypes />
          <span
            style={{
              marginLeft: '10px',
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {BULK_CUSTOM_EVENT_TYPE_BUTTON_LABEL}
          </span>
        </div>

        <style>{`
          .${styles.mainButton} svg path {
            stroke: #000;
          }
        `}
        </style>
      </button>

      <Modal
        open={modalOpen}
        setOpen={modalTrigger}
        label={BULK_CUSTOM_EVENT_TYPE_MODAL_LABEL}
        describedBy={BULK_CUSTOM_EVENT_TYPE_MODAL_DESCRIBED_BY}
        actionText={BULK_CUSTOM_EVENT_TYPE_MODAL_ACTION_TEXT}
        cancelText={BULK_CUSTOM_EVENT_TYPE_MODAL_CANCEL_TEXT}
        handleAction={submitConfirmation}
        mainContent={(
          <div className={styles.inputGroupWrapper} style={{ maxWidth: 400, width: '100%' }}>
            <BulkActionSenderForm
              eventTypeValue={customEventValue}
              setEventTypeValue={setCustomEventValue}
              validationError={validationError}
              eventTypeOptions={customEventOptions}
              setValidationError={setValidationError}
            />
          </div>
        )}
        header={BULK_CUSTOM_EVENT_TYPE_MODAL_HEADER}
        subHeader={BULK_CUSTOM_EVENT_TYPE_SUB_HEADER}
        errorMessage={dataError}
      />

      <Modal
        open={confirmBoxOpen}
        setOpen={setConfirmBoxOpen}
        label={CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_LABEL}
        describedBy={CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_DESCRIBED_BY}
        actionText={CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_ACTION_TEXT}
        cancelText={CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_CANCEL_TEXT}
        handleAction={bulkNotificationAction}
        header={CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_HEADER}
        subHeader={CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_SUB_HEADER}
      />
    </div>
  );
};

export default BulkActionSender;
